import axios from '@/core/http'

const fetchLevels = () => {
  return axios.get('sources/levels/').then(res => res.data)
}

export { fetchLevels }
